import { createElementFromHTML, getParent, tryParseJSON } from '../../js/helper';
import { AjaxLoader } from './../../js/ajax-loader';
import 'formdata-polyfill';
import { sendTracking } from './../../js/tracking';

class Materialnumberform {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-materialnumberform',
            fieldAttr: 'data-input',
            inputAttr: 'input',
            resultAttr: 'result',
            resetAttr: 'reset',
            loader: null
        };

        this.settings = Object.assign({}, defaults, options);

        this.$formHandler = element;
        this.$header = document.querySelector('[data-header="root"]');

        if (this.$formHandler.querySelector('form') === null) {
            console.error('no form found');
            return;
        }

        if (this.settings.loader !== null) {
            this.$loader = createElementFromHTML(this.settings.loader);
        }

        this.$inputDelete = this.$formHandler.querySelector('.input-delete');

        this.initialize();
    }

    initialize () {
        this.setEvents();

        this.initFormFields();
        this.formStatus = this.checkField();
    }

    checkField () {
        const $input = this.$formHandler.querySelector('[' + this.settings.initAttr + '="' + this.settings.inputAttr + '"]');
        const $button = this.$formHandler.querySelector('button[type="submit"]');
        let status = false;

        if ($input.value === '') {
            $button.setAttribute('disabled', true);
        } else {
            $button.removeAttribute('disabled');
            status = true;
        }

        return status;
    }

    initFormFields () {
        const $field = this.$formHandler.querySelector('[' + this.settings.fieldAttr + ']');
        if ($field !== null) {
            import('../../components/form/form-input').then(({ FormInput }) => {
                const formAPI = new FormInput($field);
                $field.API = formAPI;
            });

            const $input = $field.querySelector('[' + this.settings.initAttr + '="' + this.settings.inputAttr + '"]');

            $input.addEventListener('keyup', () => {
                this.formStatus = this.checkField();
            });
        }
    }

    submitForm ($form) {
        if ($form === null) {
            return;
        }

        const $button = $form.querySelector('[type="submit"]');
        if ($button) {
            $button.setAttribute('disabled', true);
            $button.appendChild(this.$loader);
        } else {
            $form.appendChild(this.$loader);
        }

        const $field = getParent($form.querySelector('[' + this.settings.fieldAttr + ']'), '.form__element');

        let formAction = $form.getAttribute('action');
        const formMethod = $form.getAttribute('method');
        const formData = new FormData($form);

        if (formMethod.toLowerCase() === 'get') {
            let queryString = '?';

            for (const entry of formData.entries()) {
                if (entry[1] !== '') {
                    queryString += encodeURIComponent(entry[0]) + '=' + encodeURIComponent(entry[1]) + '&';
                }
            }

            queryString = queryString.slice(0, -1);
            formAction = formAction + queryString;
        }

        this.formResult = new AjaxLoader(formAction, {
            requestMethod: formMethod,
            requestData: formData,
            onSuccess: (resultText) => {
                if (this.$loader !== null) {
                    this.$loader.parentNode.removeChild(this.$loader);
                }

                const result = tryParseJSON(resultText);

                if (result !== false) {
                    if (result.success === true) {
                        window.location.href = result.url;
                    } else {
                        $field.classList.add('has--error');
                    }
                } else {
                    $field.classList.add('has--error');
                }
            }
        });
    }

    setEvents () {
        const $input = this.$formHandler.querySelector('[' + this.settings.initAttr + '="' + this.settings.inputAttr + '"]');
        this.$formHandler.addEventListener('submit', (e) => {
            if (this.checkField() === true) {
                if (e.target.tagName.toLowerCase() === 'form') {
                    const trackingData = {
                        category: 'product support DT Swiss ID',
                        action: 'submit',
                        label: 'send btn ' + $input.value
                    };
                    sendTracking(trackingData);

                    this.submitForm(e.target);
                }
            }
            e.preventDefault();
        });

        if (this.$inputDelete) {
            this.$inputDelete.addEventListener('click', () => {
                const $inputToEmpty = this.$formHandler.querySelector('input');
                $inputToEmpty.value = '';
            });
        }
    }
}

export { Materialnumberform };
